import { Text } from "@amzn/stencil-react-components/text";
import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";

import { ChatWithITSupportFlyoutLink } from "@/components/GetSupport";
import { CHAT_SUPPORT_CONTEXTS_METRICS_MAP } from "@/components/GetSupport/ChatWithITSupport/constants";
import { AppContext } from "@/stores/appStore";
import {
  Day1EventAction,
  Day1EventCategory,
  Day1EventLabel,
} from "@/types/snowplow-events";
/**
 * A component that renders a help text with a chat support link.
 * Uses FormattedMessage for internationalization and includes analytics tracking.
 *
 * @param {Function} onChatClick - Optional callback triggered when chat link is clicked
 */
interface MoreHelpProps {
  onChatClick?: () => void;
}

/**
 * Renders help text with an IT support chat link
 * @component MoreHelp
 * @param {object} props
 * @param {Function} props.onChatClick - Callback fired when chat link is clicked
 * @returns {Element} Text component with formatted message and chat link
 */
export const MoreHelp = ({ onChatClick }: MoreHelpProps) => {
  const { state } = useContext(AppContext);

  const stepCategory = state.nonDirectedChatSupportContext
    ? CHAT_SUPPORT_CONTEXTS_METRICS_MAP[state.nonDirectedChatSupportContext]
        .category
    : Day1EventCategory.PageLevel;

  return (
    <Text fontSize="T100">
      <FormattedMessage
        id="faq-more-help"
        values={{
          chatWithITSupportLink: (
            <ChatWithITSupportFlyoutLink
              localeMessageId="text-chatWithITSupport"
              fontSize="T100"
              metricProps={{
                category: stepCategory,
                action: Day1EventAction.ChatWithSupport,
                label: Day1EventLabel.MoreHelp,
              }}
              onClick={onChatClick}
            />
          ),
        }}
      />
    </Text>
  );
};
